import AdminGuard from '@/auth/guard/admin-guard';
import { UserListPage, UserEditPage, UserCreatePage } from './imports';

export const userRoutes = [
  {
    path: 'users',
    children: [
      {
        element: (
          <AdminGuard hasContent>
            <UserListPage />
          </AdminGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <AdminGuard hasContent>
            <UserListPage />
          </AdminGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <AdminGuard hasContent>
            <UserEditPage />
          </AdminGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <AdminGuard hasContent>
            <UserCreatePage />
          </AdminGuard>
        ),
      },
    ],
  },
];
